<div class="onboarding-page">
  <div class="onboarding-card">
    <div class="welcome-section text-center mb-4">
      <img src="assets/jax-avatar.svg" alt="Jax" class="jax-avatar mb-3" />
      <h1 class="welcome-title">Welcome to ClassJax!</h1>
      <p class="welcome-subtitle text-muted">
        Help us personalize your experience by telling us a bit about what you teach.
      </p>
    </div>

    @if (error) {
    <div class="alert alert-danger" role="alert">
      {{ error }}
    </div>
    }

    <div class="form-section">
      <div class="mb-4">
        <label class="form-label fw-semibold">What grade level(s) do you teach?</label>
        <p class="form-text mt-0 mb-2">Select all that apply</p>
        <div class="checkbox-grid">
          @for (grade of gradeOptions; track grade) {
          <button
            type="button"
            class="checkbox-chip"
            [class.selected]="isGradeSelected(grade)"
            (click)="toggleGrade(grade)"
          >
            <span class="chip-checkbox"></span>
            {{ grade }}
          </button>
          }
        </div>
      </div>

      <div class="mb-4">
        <label class="form-label fw-semibold">What subjects do you teach?</label>
        <p class="form-text mt-0 mb-2">Select all that apply</p>
        <div class="checkbox-grid">
          @for (subject of subjectOptions; track subject) {
          <button
            type="button"
            class="checkbox-chip"
            [class.selected]="isSubjectSelected(subject)"
            (click)="toggleSubject(subject)"
          >
            <span class="chip-checkbox"></span>
            {{ subject }}
          </button>
          }
        </div>
      </div>

      <div class="mb-4">
        <label class="form-label fw-semibold">What type of school?</label>
        <p class="form-text mt-0 mb-2">Select one</p>
        <div class="radio-grid">
          @for (type of schoolTypeOptions; track type) {
          <button
            type="button"
            class="radio-chip"
            [class.selected]="data.school_type === type"
            (click)="selectSchoolType(type)"
          >
            <span class="chip-radio"></span>
            {{ type }}
          </button>
          }
        </div>
      </div>

      <div class="mb-4">
        <label class="form-label fw-semibold">Where do you teach?</label>
        <p class="form-text mt-0 mb-2">This helps us show relevant educational standards</p>
        <div class="radio-grid">
          @for (state of stateOptions; track state) {
          <button
            type="button"
            class="radio-chip"
            [class.selected]="data.teaching_state === state"
            (click)="selectState(state)"
          >
            <span class="chip-radio"></span>
            {{ state }}
          </button>
          }
        </div>
      </div>
    </div>

    <div class="action-buttons">
      <button type="button" class="btn btn-link text-muted" (click)="skip()">
        Skip for now
      </button>
      <button
        type="button"
        class="btn btn-primary btn-lg px-4"
        (click)="save()"
        [disabled]="isLoading"
      >
        @if (isLoading) {
        <span
          class="spinner-border spinner-border-sm me-2"
          role="status"
          aria-hidden="true"
        ></span>
        }
        Get Started
      </button>
    </div>
  </div>
</div>
